import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { TpProgressBarCardComponent } from 'app/components/tp-progress-bar-card/tp-progress-bar-card.component'

@NgModule({
    declarations: [TpProgressBarCardComponent],
    imports: [CommonModule],
    exports: [TpProgressBarCardComponent],
})
export class TpProgressBarCardModule {}